import { PageWidgetType } from '@efdigital/ll-addon-data';
import { DataTypeContent } from '@efdigital/ll-addon-data/data-types';
import type {
  PageWidgetExternalLink,
  PageWidgetExternalLinkLike,
} from '@efdigital/ll-addon-data/types/content/objects/page-widget-external-link';
import { uniqueId } from '@ember/helper';
import { on } from '@ember/modifier';
import Component from '@glimmer/component';

import type {
  PageWidgetComponentSignature,
  WidgetEditor,
} from '../page-widget-signature.ts';

export class PageWidgetExternalLinkComponent extends Component<PageWidgetComponentSignature> {
  get widget() {
    return this.args.widget as PageWidgetExternalLink;
  }

  setHref = (event: Event) => {
    const href = (event.target as HTMLInputElement).value;
    this.widget.href = href;
  };

  setLinkCss = (event: Event) => {
    const linkCss = (event.target as HTMLInputElement).value;
    this.widget.linkCss = linkCss;
  };

  <template>
    {{#let (uniqueId) as |uniqueId|}}
      <div class="card-body">
        <div class="form-group mb-4">
          <label for="{{uniqueId}}-href">External link</label>
          <input
            class="form-control"
            id="{{uniqueId}}-href"
            type="url"
            value={{this.widget.href}}
            {{on "change" this.setHref}}
          />
        </div>
        <div class="form-group mb-4">
          <label for="{{uniqueId}}-linkCss">Link CSS</label>
          <input
            class="form-control"
            id="{{uniqueId}}-linkCss"
            type="text"
            value={{this.widget.linkCss}}
            {{on "change" this.setLinkCss}}
          />
        </div>
      </div>
    {{/let}}
  </template>
}

const DEFAULT_WIDGET_EXTERNAL_LINK: Omit<PageWidgetExternalLinkLike, 'wid'> = {
  widgetType: PageWidgetType.ExternalLink,
  title: 'External Link',
  css: '',
  href: '',
  linkCss: 'btn btn-primary',
};

export const ExternalLinkWidgetEditor: WidgetEditor = {
  icon: 'ph:arrow-square-out-bold',
  label: 'External Link',
  component: PageWidgetExternalLinkComponent,
  dataType: DataTypeContent.PageWidgetExternalLink,
  widgetData: DEFAULT_WIDGET_EXTERNAL_LINK,
};
